import { render, staticRenderFns } from "./DoubleBtn.vue?vue&type=template&id=63a599da&"
import script from "./DoubleBtn.vue?vue&type=script&lang=js&"
export * from "./DoubleBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports